import React, {useState, useEffect} from 'react';
import {AdminUpdate} from "../components/adminUpdate/AdminUpdate";
import {authService} from "../service/auth/auth.service";
import {getStoreLocationService} from "../service/storeLocator/storeLocator.service";
import {isValidDate} from "../utils/dateValidator";
import {useAuth0} from "@auth0/auth0-react";
import "../components/adminUpdate/Update.css";
import {useNavigate} from "react-router-dom";


function AdminUpdatePage(customProps) {
    const navigate = useNavigate();

    const {alert, showAlert} = customProps;
    const {getIdTokenClaims, isAuthenticated} = useAuth0();
    const [auth0Details, setAuth0Details] = useState(null);
    const [lookUpResponse, setLookUpResponse] = useState();
    const [employeeStatusList, setEmployeeStatusList] = useState([]);
    const queryString = window.location.search;
    const [registering, setRegistering] = useState(false);
    const [lookingUp, setLookingUp] = useState(false);

    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNo: '',
        storeLocation: '',
        storeNumber: '',
        customerId: '',
        birthday: ''
    });
    const [error, setError] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNo: '',
        storeLocation: '',
        customerId: '',
        birthday: ''
    });
    const [comparisonSummary, setComparisonSummary] = useState(false);
    const [userName, setUserName] = useState();
    const [userImage, setUserImage] = useState();
    const [cosmosCustomer, setCosmosCustomer] = useState(null);
    const [showSummary, setShowSummary] = useState(false);
    const handleSummaryClose = () => {
        setShowSummary(false);

    };
    const handleSummaryShow = () => {
        setShowSummary(true);
    }
    const [stores, setStores] = useState([]);
    const [autoSet, setAutoSet] = useState(false);


    useEffect(() => {
        if (!isAuthenticated) return;

        const getClaims = async () => {
            try {
                const claims = await getIdTokenClaims();
                setUserName(claims?.nickname);
                setUserImage(claims?.picture);
            } catch (err) {
                console.error("Error fetching claims:", err);
            }
        };
        getClaims().then(r => console.log("Claims fetched successfully"))
            .catch(err => console.error("Error in getClaims:", err));
        return () => {

        };
    }, [isAuthenticated, getIdTokenClaims]);


    useEffect(() => {
        if (!stores.length) {
            getStoreLocationService.getStoreLocator()
                .then((data) => {
                    if (data) {
                        let stores = data.Stores;
                        stores = stores.filter((store) => {
                            if (store.ecomName) {
                                store.originalEcomName = store.ecomName;
                                return store;
                            }
                            return null;
                        })
                        setStores(stores);
                    }
                })
        }

    }, [stores.length]);


    const handleChange = (event) => {
        const {name, value} = event.target;

        setCosmosCustomer((prev) => ({
            ...prev,
            [name]: value,
        }));

        setUser((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const changeStoreLocation = (event) => {
        handleChange(event);
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (validate()) {
            setRegistering(true);

            authService.updateProfile({...cosmosCustomer, customerId: cosmosCustomer.id}).then(
                (data) => {
                    if (data && !data?.error) {
                        showAlert("AdminUpdate successful!", "success");

                        setTimeout(() => {
                            navigate("/admin/update/profile");
                        }, 4000);
                    } else {
                        showAlert(data?.error, "danger");
                    }

                    setRegistering(false);
                },
                (error) => {
                    showAlert(error?.message || error, "danger");
                    setRegistering(false);
                }
            );
        }
    };

    const handleSetValues = (data, birthday) => {
        setAutoSet(true);
        if (!data) {
            showAlert("Data not available", "danger");
            return;
        }
        setUser(JSON.parse(JSON.stringify({
            customerId: data?.id ?? "",
            firstName: data?.firstName ?? "",
            lastName: data?.lastName ?? "",
            phoneNo: data?.phoneNo ?? "",
            email: data?.email ?? "",
            storeNumber: data?.storeNumber ?? "",
            birthday: birthday ?? user.birthday
        })));
        setAutoSet(false);
    }


    const handleLookup = (event) => {
        event.preventDefault();

        if (validateLookUpField()) {
            setLookingUp(true);
            authService.lookUpAccount(lookupData).then(data => {
                    if (data && !data?.error) {
                        setLookUpResponse(JSON.parse(JSON.stringify(data)));
                        setAuth0Details(data?.meta?.auth0Details);
                        setComparisonSummary(data?.meta?.comparisonSummary?.compareDataSummary??false)
                        const wynshopResponse = data?.meta?.wynshopCustomer;
                        setEmployeeStatusList(data?.meta?.employeeStatusList ?? []);
                        if (wynshopResponse) {
                            const cosmosdata = data?.data?.find(cosmos =>
                                cosmos.id === wynshopResponse.id
                            );
                            setCosmosCustomer(cosmosdata);
                            handleSetValues(wynshopResponse, cosmosdata?.birthday);
                        } else {
                            setCosmosCustomer(null);
                            setUser(JSON.parse(JSON.stringify({
                                firstName: '',
                                lastName: '',
                                email: '',
                                phoneNo: '',
                                storeLocation: '',
                                storeNumber: '',
                                customerId: '',
                                birthday: ''
                            })));
                        }
                        showAlert('Look up successful!', "success");
                        handleSummaryShow();
                    } else {
                        setCosmosCustomer(null);
                        setLookUpResponse(null);
                        showAlert(data?.error, "danger")
                    }
                    setLookingUp(false);
                }, error => {
                    setCosmosCustomer(null);
                    setLookUpResponse(null);
                    setLookingUp(false);
                    showAlert("Service not available", "danger");
                }
            );
        }
    }

    const [lookupError, setLookupError] = useState({
        searchValue: '',
        fieldType: ''

    });

    const [lookupData, setLookupData] = useState({
        searchValue: '',
        fieldType: ''

    });
    const validateLookUpField = () => {

        let input = lookupData;
        let errors = {};
        let isValid = true;

        if (!input["searchValue"]) {
            isValid = false;
            lookupError["searchValue"] = "Please enter Search Value.";
        }
        setLookupError(
            errors
        );
        return isValid;
    }

    const validate = () => {
        let pattern;
        let input = cosmosCustomer;
        let errors = {};
        let isValid = true;

        if (!input["id"]) {
            isValid = false;
            errors["customerId"] = "Please enter Customer ID.";
        }

        if (!input["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        if (!input["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }

        if (!input["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email Address.";
        }

        if (input["birthday"]) {
            errors["birthday"] = isValidDate(input["birthday"]);
            if (errors["birthday"]) {
                isValid = false;
            } else {
                errors["birthdaySuccess"] = "Get a special reward for your birthday every year";
            }
        }

        if (typeof input["email"] !== "undefined") {

            pattern = new RegExp(/^(("[\w-\s]+")|([+\w-]+(?:\.[+\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

            if (!pattern.test(input["email"])) {
                isValid = false;
                errors["email"] = "Please enter a valid email address.";
            }
        }

        if (!input["storeNumber"]) {
            isValid = false;
            errors["storeNumber"] = "Please select store nearby.";
        }

        if (!input["phoneNo"]) {
            isValid = false;
            errors["phoneNo"] = "Please enter your phone number.";
        }


        if (typeof input["phoneNo"] !== "undefined") {
            pattern = new RegExp(/^[0-9\b]+$/);

            if (!pattern.test(input["phoneNo"])) {
                isValid = false;
                errors["phoneNo"] = "Please enter only numbers.";
            } else if (input["phoneNo"].length !== 10) {
                isValid = false;
                errors["phoneNo"] = "Please enter a valid phone number.";
            }
        }
        setError(
            errors
        );
        return isValid;
    }

    const props = {
        handleSubmit,
        handleChange,
        error,
        stores,
        queryString,
        changeStoreLocation,
        registering,
        alert,
        lookupData,
        setLookupData,
        lookupError,
        setLookupError,
        lookingUp,
        handleLookup,
        lookUpResponse,
        user,
        handleSetValues,
        showSummary,
        handleSummaryClose,
        autoSet,
        setUser,
        showAlert,
        setLookUpResponse,
        userName,
        setUserName,
        employeeStatusList,
        auth0Details,
        userImage, cosmosCustomer, comparisonSummary
    };
    return <AdminUpdate {...props}/>
}

export default AdminUpdatePage;
